import { create } from 'zustand';

interface SupportChatStore {
  incomingMessageExists: number;
  setIncomingMessage: (exists: number) => void;
  isSupportChatOpen: boolean;
  setOpenSupportChat: (v: boolean) => void;
}

export const useSupportChatStore = create<SupportChatStore>((set) => ({
  incomingMessageExists: 0,
  setIncomingMessage: (exists) => set({ incomingMessageExists: exists }),
  isSupportChatOpen: false,
  setOpenSupportChat: (v: boolean) => set({ isSupportChatOpen: v }),
}));
